import './Pricing.css';
import Cta from "./Cta";
import Footer from './Footer';
import FAQSection from './FAQSection';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from 'react'; // <-- Ensure useState is imported
import PricingSection from './PricingSection';

const Pricing = () => {
    // Add state to track login status
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        // Check for login status from localStorage when the component mounts
        const loginStatus = localStorage.getItem('isLoginTrue');
        if (loginStatus === 'true') {
            setIsLoggedIn(true);
        }
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <>
            <Helmet>
                <meta name="title" content="Pricing | Get Next Visa - AI Powered Student Visa Report" />
                <title>Pricing | Get Next Visa - AI Powered Student Visa Report</title>
                <meta name="description" content="Get personalized, AI-powered visa reports. Discover the best countries and colleges for your study abroad journey." />
            </Helmet>

            {/* section 1 */}
            <section className="pricing-main">
                <div className="pricing-container">
                    <div className="pricing-breadcrumb">Transparent, One-Time Pricing for Every Student </div>
                    <h1 className="main-title">Choose Your Perfect
                        <span className='highlight'> Immigration Plan </span></h1>
                    <p className="pricing-description">
                       Whether you’re exploring study options or already know your destination, our plans are designed to match every stage of your study abroad journey.
                    </p>
                    
                    {/* --- MODIFICATION HERE --- */}
                    <div className="pricing-buttons">
                        {isLoggedIn ? (
                            <Link to="/dashboard?view=get-ai-report" aria-label="One-time Payment" className="pricing-btn pricing-btn-primary">
                                Get AI Report
                            </Link>
                        ) : (
                            <a aria-label="One-time Payment" className="pricing-btn pricing-btn-primary trigger-login-popup">
                                Get AI Report
                            </a>
                        )}
                        {isLoggedIn ? (
                             <Link to="/dashboard?view=counselling" aria-label="With Consultation" className="pricing-btn pricing-btn-secondary">
                                With Consultation
                             </Link>
                        ) : (
                            <a aria-label="With Consultation" className="pricing-btn pricing-btn-secondary trigger-login-popup">
                                With Consultation
                            </a>
                        )}
                    </div>
                </div>
            </section>

            {/* section 2 */}
            <PricingSection isLoggedIn={isLoggedIn} />


            {/* section 3 */}
            <section className="every-section">
                <div className="every-container">
                    <h2 className="ai-title">What You’ll Discover in Your AI Report</h2>
                    <p className="ai-description">
                        Every plan—Basic through Complete—includes these game‑changing insights to power your study‑abroad journey:
                    </p>
                    <div className="every-grid">
                        <div className="every-card fade-in" >
                            <div className="every-iconn">
                                <img src="/photos/unt11.png" alt="USA Study Visa Eligibility" loading="lazy" />
                            </div>
                            <h3 className="every-title">Personalized University Score</h3>
                            <p className="every-description">
                              A ranked list of 3–5 best‑fit schools, scored on your academics and goals. </p>
                        </div>
                        <div className="every-card fade-in" >
                            <div className="every-iconn">
                                <img src="/photos/de4.png" alt="PR in Australia" loading="lazy"/>
                            </div>
                            <h3 className="every-title">Dynamic Cost Simulator</h3>
                            <p className="every-description">
                                 Interactive tool that shows real‑time tuition, living, and travel estimates. </p>
                        </div>
                        <div className="every-card fade-in">
                            <div className="every-iconn">
                                <img src="/photos/sg5.png" alt="PR in Singapore" loading="lazy" />
                            </div>
                            <h3 className="every-title">Real‑Time Visa Alerts</h3>
                            <p className="every-description">
                                Up‑to‑the‑minute notifications on rule changes, embassy wait times, and document updates.  </p>
                        </div>
                        <div className="every-card fade-in">
                            <div className="every-iconn">
                                <img src="/photos/unt4.png" alt="Singapore Student Visa Eligibility" loading="lazy" />
                            </div>
                            <h3 className="every-title">Scholarship Match Engine</h3>
                            <p className="every-description">
                                Instant list of scholarships and grants you qualify for—maximizing your funding  </p>
                        </div>
                        <div className="every-card fade-in">
                            <div className="every-iconn">
                                <img src="/photos/unt3.png" alt="Singapore education visa" loading="lazy" />
                            </div>
                            <h3 className="every-title">AI Career Route Map</h3>
                            <p className="every-description">
                               Custom post‑study job market analysis, salary forecasts, and PR pathway odds.  </p>
                        </div>
                        <div className="every-card fade-in">
                            <div className="every-iconn">
                                <img src="/photos/unt8.png" alt="Singapore education visa document requirements" loading="lazy"/>
                            </div>
                            <h3 className="every-title">Document Prep Assistant</h3>
                            <p className="every-description">
                               Step‑by‑step guidance—and automated checklists—for every application form and SOP.  </p>
                        </div>
                    </div>
                </div>
            </section>
            
            <FAQSection />

            {/* section 5 */}
            <Cta />
            {/* <Footer /> */}
        </>
    )
}

export default Pricing;